var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipbobLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02 Branding/Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02-Branding/Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00375846,18.2497479 L8.00375846,27.4270113 L20.5000309,34.7689205 L33.0093962,27.4270113 L33.0093962,15.3653737 L22.3434071,21.6061195 C21.1714724,22.2876749 19.8283423,22.2876749 18.6564077,21.6061195 L4.14556369,13.0973756 C2.61814544,12.1927343 2.61814544,9.92449025 4.14556369,9.03313083 L18.6564077,0.511351059 C19.8283423,-0.170450353 21.1714724,-0.170450353 22.3434071,0.511351059 L33.0093962,6.77816858 L28.0978436,9.64926089 L20.5000309,5.20476179 L16.9447012,7.30255553 L10.5188232,11.091325 L13.9029575,13.0710579 L20.5000309,16.9781341 L33.9837027,9.08552033 C34.7475354,8.6528765 35.7878003,8.70526601 36.551386,9.09855621 C37.3809299,9.53120004 38,10.3834518 38,11.4324717 L38,28.2268736 C38,29.537841 37.3414043,30.678358 36.2089953,31.3471235 L22.3434071,39.4886489 C21.1848123,40.1704504 19.8283423,40.1704504 18.6564077,39.4886489 L4.79081947,31.3471235 C3.6584104,30.678358 3.01315462,29.5508768 3.01315462,28.2268736 L3.01315462,25.5653393 L3.01315462,15.339302 L8.00375846,18.2497479 Z",
    id: "Fill-12",
    fill: "#175CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipbobLogo);
export default __webpack_public_path__ + "static/media/shipbob-logo.5ce05e6cf5206c90702e4c039dddd627.svg";
export { ForwardRef as ReactComponent };